import React, { useState } from 'react';
import { ArrowUpRight, Wallet as WalletIcon, CheckCircle, Zap } from 'lucide-react';
import '../styles/global.css';

// WEB3 Imports
import { useWeb3 } from '../context/Web3Context';

const Wallet = () => {
  // Mock Balance
  const [balance, setBalance] = useState(120); // 120 GUARD Tokens
  const [upiId, setUpiId] = useState('');
  const [amount, setAmount] = useState('');
  const [status, setStatus] = useState('idle'); // idle, processing, success

  // 1 GUARD = ₹5 (Simulated Price)
  const exchangeRate = 5; 

  const { account, switchToMonad } = useWeb3();

  // --- MONAD TECH INTEGRATION ---
  const handleSwitchNetwork = async () => {
    await switchToMonad();
  };

  const handleWithdraw = (e) => {
    e.preventDefault();
    if (amount > balance) return alert("Insufficient Balance!");
    
    setStatus('processing');

    // Simulate High-Speed Monad Transaction (1 Second Finality)
    setTimeout(() => {
      setBalance(prev => prev - amount);
      setStatus('success');
      
      // Reset after showing success
      setTimeout(() => setStatus('idle'), 3000);
    }, 1000); 
  };

  return (
    <div className="container" style={{ paddingTop: '100px', maxWidth: '500px', margin: '0 auto', paddingBottom: '40px' }}>
      
      {/* 1. THE MONAD BRANDED CARD */}
      <div className="glass-panel" style={{ 
        background: 'linear-gradient(135deg, #8b5cf6 0%, #4c1d95 100%)', // Monad Purple Gradient
        padding: '30px', borderRadius: '24px', color: 'white', marginBottom: '30px',
        boxShadow: '0 10px 30px rgba(139, 92, 246, 0.4)', position: 'relative', overflow: 'hidden'
      }}>
        {/* Background decorative circle */}
        <div style={{ position:'absolute', top:'-20px', right:'-20px', width:'100px', height:'100px', background:'rgba(255,255,255,0.1)', borderRadius:'50%' }}></div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <span style={{ opacity: 0.9, fontSize: '0.9rem', display:'flex', alignItems:'center', gap:'6px' }}>
            <Zap size={16} fill="yellow" color="yellow"/> Monad Testnet
          </span>
          <WalletIcon size={20} style={{ opacity: 0.8 }} />
        </div>
        <div style={{ fontSize: '3rem', fontWeight: 'bold' }}>
          {balance} <span style={{ fontSize: '1.2rem', fontWeight: '500' }}>GUARD</span>
        </div>
        <div style={{ marginTop: '5px', opacity: 0.9, fontSize: '1rem' }}>
          ≈ ₹{balance * exchangeRate} INR
        </div>
      </div>

      {/* 2. WITHDRAW FORM */}
      <div className="glass-panel" style={{ padding: '24px' }}>
        <h3 style={{ marginBottom: '20px', fontWeight: 'bold', color: 'var(--text-main)' }}>DePIN Rewards</h3>
        
        {status === 'success' ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#10b981' }}>
            <div style={{ display:'flex', justifyContent:'center', marginBottom:'10px' }}>
              <CheckCircle size={48} />
            </div>
            <h3>Transfer Complete!</h3>
            <p style={{ color: 'var(--text-muted)' }}>
              Transaction Hash: 0x71...9A<br/>
              <span style={{fontSize:'0.8rem'}}>Confirmed in 0.8s on Monad</span>
            </p>
          </div>
        ) : (
          <form onSubmit={handleWithdraw}>
            
            {/* Amount Input */}
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                Tokens to Withdraw
              </label>
              <div style={{ position: 'relative' }}>
                <input 
                  type="number" 
                  placeholder="0" 
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="glass-input" /* FIXED: Uses transparent glass styling */
                  style={{ paddingRight: '60px', fontSize: '1.2rem', fontWeight: 'bold' }}
                  required
                />
                <span style={{ position: 'absolute', right: '15px', top: '14px', fontWeight: 'bold', color: 'var(--text-muted)' }}>MAX</span>
              </div>
              {amount && (
                <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#10b981' }}>
                  You will receive: ₹{amount * exchangeRate}
                </div>
              )}
            </div>

            {/* UPI ID Input */}
            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                UPI ID (PhonePe/GPay)
              </label>
              <input 
                type="text" 
                placeholder="username@okaxis" 
                value={upiId}
                onChange={(e) => setUpiId(e.target.value)}
                className="glass-input" /* FIXED: Uses transparent glass styling */
                required
              />
            </div>

            {/* Action Button */}
            <button 
              type="submit" 
              className="btn-primary" 
              disabled={status === 'processing'}
              style={{ width: '100%', padding: '16px', fontSize: '1.1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}
            >
              {status === 'processing' ? 'Confirming on Chain...' : (
                <>
                  Withdraw Fiat <ArrowUpRight size={20} />
                </>
              )}
            </button>
            
            {/* MONAD SWITCH BUTTON */}
            <button 
              type="button"
              onClick={handleSwitchNetwork}
              className="glass-btn"
              style={{ width: '100%', marginTop: '15px', fontSize: '0.85rem', color: '#8b5cf6', borderColor: 'rgba(139, 92, 246, 0.3)' }}
            >
              ⚙️ Switch Network to Monad
            </button>

            <p style={{ textAlign: 'center', fontSize: '0.75rem', marginTop: '15px', color: 'var(--text-muted)' }}>
              Powered by <strong>Monad</strong> Parallel EVM
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default Wallet;